import { Modal, ModalBody } from 'reactstrap'
import { ControlPanelAction, ControlPanelClose } from 'modules/pages/styles'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { toggleCreateItemsPopup_action } from 'store/actions'
import { connect } from 'react-redux'

import { ReactComponent as CreateFirstPage } from 'assets/images/icons/create-first-page.svg'
import { ReactComponent as CreateFirstResponse } from 'assets/images/icons/create-first-response.svg'
import { CreateItemBox, CreateItemBoxOuter, CreateItemPopupSubTitle, CreateItemPopupTitle } from 'modules/mainmenu/styles'
import { CustomButton } from 'modules/auth/styles'
import { history } from 'store/store'

const OnboardingCreateItemsPopup = (props) => {
  const { toggleCreateItemsPopup } = props
  const goToCreateLink = (e) => {
    const module = e.target.attributes['data-target']?.value === 'pages' ? '/pages/drafts' : '/responses'
    history.push(`${module}/create`)
    toggleCreateItemsPopup(false)
  }
  return (
    <>
      <Modal
        isOpen
        centered
        wrapClassName='createItemPopup'
        toggle={() => {
          history.replace('/')
          toggleCreateItemsPopup(false)
        }}>
        <ModalBody className='p-0'>
          <ControlPanelAction>
            <ControlPanelClose
              onClick={() => {
                history.replace('/')
                toggleCreateItemsPopup(false)
              }}>
              <CloseIcon />
            </ControlPanelClose>
          </ControlPanelAction>
          <div className='pt-0 px-5 pb-5'>
            <CreateItemPopupTitle>You're all set 🙌</CreateItemPopupTitle>
            <CreateItemPopupSubTitle>Start with creating your first page or response</CreateItemPopupSubTitle>
            <CreateItemBoxOuter className='justify-content-center'>
              <CreateItemBox>
                <div className='svg'>
                  <CreateFirstPage />
                </div>
                <div className='type-name'>Pages</div>
                <div className='type-text'>For long-form, important company information shared with individuals, teams, or the whole company.</div>
                <CustomButton type='button' className='black' data-target='pages' onClick={goToCreateLink}>
                  Create a New Page
                </CustomButton>
              </CreateItemBox>
              <CreateItemBox>
                <div className='svg'>
                  <CreateFirstResponse />
                </div>
                <div className='type-name'>Responses</div>
                <div className='type-text'>For short, copyable answers to help you stop repeating yourself with customers or teammates.</div>
                <CustomButton type='button' className='black' data-target='responses' onClick={goToCreateLink}>
                  Create a New Response
                </CustomButton>
              </CreateItemBox>
            </CreateItemBoxOuter>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

const mapStateToProps = () => ({})
const mapDispatchToProps = (dispatch) => ({
  toggleCreateItemsPopup: (status) => dispatch(toggleCreateItemsPopup_action(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingCreateItemsPopup)
